import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  inject,
} from '@angular/core';
import { UniversalSearchService } from '../../../../universal-search/services/universal-search.service';
import { CustomFiltersService } from '../../../../services/custom-filters.service';
import { SessionStorageService } from '../../../../services/session-storage.service';
import { Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-multiselect-filter',
  templateUrl: './multiselect-filter.component.html',
  styleUrls: ['./multiselect-filter.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MatInputModule, MatSelectModule],
})
export class MultiselectFilterComponent implements OnDestroy {
  private ss = inject(SessionStorageService);
  usServ = inject(UniversalSearchService);
  cstmFltrSrvc = inject(CustomFiltersService);

  @Input() field;
  @Input() filterForm;
  @Input() groupKey;
  @Output() selectionChange = new EventEmitter();
  @Output() clearFilter = new EventEmitter();
  unsubscribe = new Subject();

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  selected(event): void {
    if (this.field.controlType === 'multiselect') {
      this.selectionChange.emit({
        option: {
          value: event['value'],
        },
      });
    }
  }
}
